module.exports = __webpack_public_path__ + "img/tooFacedGloss1.1d428186.jpg";